import React from 'react';
import { Modal, Button } from 'antd';

export default function BulkOrderDeleteModal({ open, onCancel, onConfirm, bulkOrder, loading }) {
  return (
    <Modal
      title="Delete bulk order"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="delete"
          danger
          onClick={onConfirm}
          loading={loading}
          className="app-btn-delete"
        >
          Delete
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
    >
      {bulkOrder && (
        <>
          Are you sure you want to delete bulk order <strong>{bulkOrder.bulkOrderNumber}</strong> (
          {bulkOrder.customerName})?
        </>
      )}
    </Modal>
  );
}
